export default __webpack_public_path__ + "static/media/i-interior-1_sura.f4809dbf.svg";